;(function () {
  'use strict'

  angular.module('admin.product.service', []).factory('ProductService', ProductService)

  /** @ngInject */
  function ProductService($http, $q, API) {
    function list() {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/products/game_tokens')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listTranslations(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/products/' + id + '/product_translations')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listInactive(start, limit, sort, productType) {
      var defered = $q.defer()

      var types = `&type=${productType}`
      if (!productType) {
        types = ''
      }

      $http
        .get(
          API.API_URL +
            'admin/products/unpublished?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort +
            types,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listActive(start, limit, sort, productType) {
      var defered = $q.defer()

      var types = `&type=${productType}`
      if (!productType) {
        types = ''
      }

      $http
        .get(
          API.API_URL +
            'admin/products/published?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort +
            types,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listArchived(start, limit, sort, productType) {
      var defered = $q.defer()

      var types = `&type=${productType}`
      if (!productType) {
        types = ''
      }

      $http
        .get(
          API.API_URL +
            'admin/products/archived?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort +
            types,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function get(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/products/' + id).success(defered.resolve)

      return defered.promise
    }

    function getTranslation(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/product_translations/' + id).success(defered.resolve)

      return defered.promise
    }

    function save(model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/products', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function saveTranslation(id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/products/' + id + '/product_translations?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function update(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/products/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateTranslation(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'admin/product_translations/' + id + '?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/products/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeTranslation(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/product_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function publish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/products/' + id + '/publish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function unpublish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/products/' + id + '/unpublish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function archive(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/products/' + id + '/archive')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listProductSegmentation(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/products/' + id + '/user_segments').success(defered.resolve)

      return defered.promise
    }

    function listSegmentation() {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/user_segments').success(defered.resolve)

      return defered.promise
    }

    function addProductSegmentation(id, segmentId) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/products/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeProductSegmentation(id, segmentId) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/products/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve)

      return defered.promise
    }

    return {
      list: list,
      listInactive: listInactive,
      listActive: listActive,
      listArchived: listArchived,
      listTranslations: listTranslations,
      get: get,
      getTranslation: getTranslation,
      save: save,
      saveTranslation: saveTranslation,
      update: update,
      updateTranslation: updateTranslation,
      remove: remove,
      publish: publish,
      unpublish: unpublish,
      archive: archive,
      listProductSegmentation: listProductSegmentation,
      listSegmentation: listSegmentation,
      addProductSegmentation: addProductSegmentation,
      removeProductSegmentation: removeProductSegmentation,
      removeTranslation: removeTranslation,
    }
  }
})()
